import { Button } from "../components/Button";
import Modal from "../components/Modal";

export function ComplianceAcknowledgement({ onAcceptCompliance, complianceText, title }: { onAcceptCompliance: () => void, complianceText: string, title: string }) {
    return (
        <Modal
            isOpen={true}
            title={title}
            contentClassName="[&_.title]:!text-[25px] [&_.title]:!font-medium [&_.title-container]:!justify-center"
        >
            <div className="flex flex-col gap-8 mt-4">
                <div className="text-center text-lg whitespace-pre-line">{complianceText}</div>
                <div className="text-center font-semibold">
                    By clicking "I acknowledge", I agree that I have read and understand the information stated above.
                </div>
                <div className="flex justify-center">
                    <Button variant="primary" className="!w-[50%] !rounded-full" onClick={onAcceptCompliance}>I Acknowledge</Button>
                </div>
            </div>
        </Modal>
    );
}
